export const REACT_APP_DEBUG = false

export const DEFAULT_POLYGON_STYLE = {
  strokeWeight: 0,
  fillColor: '#FFA621',
  fillOpacity: 0.55,
}
export const PROTOCOL = 'https://'
export const OLD_WEB = 'www.telecompra.mercadona.es'
export const OLD_URL_DOMAIN = `${PROTOCOL}${OLD_WEB}/ns/entrada.php?js=1&nidioma=`

export const OLD_SHOP_LANGUAGES_ID = {
  es: 1,
  vai: 3,
  ca: 2,
  gl: 7,
  eu: 11,
  en: 5,
  de: 6,
}

export const OLD_SHOP_LANGUAGES = {
  es: 'es',
  vai: 'va',
  ca: 'ca',
  gl: 'gl',
  eu: 'eu',
  en: 'en',
  de: 'de',
}

export const CUSTOMER_SERVICE_LINKS = {
  es: '/atencion-al-cliente',
  va: '/atencio-al-client',
  ca: '/atencio-al-client-0',
  gl: '/atencion-ao-cliente',
  eu: '/bezeroaren-arreta',
  en: '/customer-service',
  de: '/kundenservice',
}

export const MEDIAQUERIES = {
  MEDIUMVIEWPORT: '(min-width: 768px)',
  LARGEVIEWPORT: '(min-width: 992px)',
  HDVIEWPORT: '(min-width: 1200px)',
  EXTRAHDVIEWPORT: '(min-width: 1440px)',
}

export const mercadonaDomain = 'https://info.mercadona.es/'
export const mercadonaDomainPortugal = 'https://www.mercadona.pt/'
